// extracted by mini-css-extract-plugin
export default {"backdrop":"AddTaskModal_backdrop__oH5L3","modal":"AddTaskModal_modal__tXKAh","slide-down":"AddTaskModal_slide-down__OYM4c"};